
import { useRef, useState } from 'react'
import { translate } from "@/utils/translate";

import s from './NewsletterForm.module.scss'
import { LanguageContext } from "@/context/languageContext";
import { useContext } from "react";

export default function NewsletterForm() {
  const inputRef = useRef<HTMLInputElement>(null);
  const [result, setResult] = useState<Response | null>(null)
  const [showMessage, setShowMessage] = useState(false);

  const { language } = useContext(LanguageContext);

  const subscribeUser = async (e: React.FormEvent) => {
    e.preventDefault()

    if (inputRef.current) {

      const res = await fetch('/api/subscribe', {
        body: JSON.stringify({
          email: inputRef.current.value
        }),
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST'
      })
      setResult(res)
      // Clear input value
      inputRef.current.value = '';

      // Show message based on response
      setShowMessage(true);

      // Automatically hide message after 3 seconds
      setTimeout(() => {
        setShowMessage(false);
      }, 3000);
      setTimeout(() => {
        setResult(null);
      }, 3400);
    }
  }

  return (
    <>
      <form
        onSubmit={subscribeUser}
        className={s.form}
      >
        <label htmlFor="email">{translate["signUpNews"][language]}</label>
        <input
          type="email"
          name="email"
          id="email"
          placeholder={translate["yourEmail"][language]}
          ref={inputRef}
          required
          autoCapitalize="off"
          autoCorrect="off"
          autoComplete="off"
          onClick={() => { setResult(null); setShowMessage(false); }}
        />
        <button
          type="submit"
        >
          {translate["subscribe"][language]}
        </button>
        <div className={`${s.answer} ${showMessage ? s.show : s.hide}`}>
          {result && result.status == 200 ? translate["formNewsletterSuccess"][language] : result && result.status == 400 ? translate["formNewsletterExisting"][language] : undefined}
        </div>
      </form>
    </>
  );
}